import { makeQueryStringDync, makeQueryFormDataDyn, errorServeiceHandler } from '../../helper'
const state = {
  
}
const getters = {
}
const mutations = {
  
}
let planListingData = []
const actions = {
  getAddPacks: (context, filterData) => {
    let newurl = filterData.url
    delete filterData.url
    return new Promise( (resolve, reject) => {
      //Remove Multiple call code
      if (newurl == '/lco/v1/plan/subscriber' &&  filterData.plantype != 'ONEDIGITAL') {
        let getRecordBySearch = JSON.parse(localStorage.getItem('getRecordBySearch'))
        let lastCustomerSearch = JSON.parse(localStorage.getItem('lastCustomerSearch'))
        if (getRecordBySearch && lastCustomerSearch) {
          if (Object.keys(getRecordBySearch).length && lastCustomerSearch == filterData.subscriberid) {
            resolve(getRecordBySearch)
            return
          }
        }
      }
      //Remove Multiple call code End

      let queryStr = ''
      queryStr = makeQueryStringDync(filterData)

      //Remove multiple call for plan start
        if (newurl == '/lco/v1/plan.php') {
          if (planListingData.length) {
            for (let i in planListingData) {
              console.log(planListingData[i], queryStr)
              if (Object.keys(planListingData[i]) == queryStr) {
                resolve(planListingData[i][queryStr]) 
                console.log(planListingData[i][queryStr])
                return
              }
            }
          }
        }
      //Remove multiple call for plan end

      fetch(context.getters.baseUrl + newurl + queryStr, {
        method: 'GET'
        })      
        .then(errorServeiceHandler)
        .then((response) => {
            return response.json();
          }).then((data) => {
            if (newurl == '/lco/v1/plan/subscriber' && !data.error) {
              localStorage.setItem("getRecordBySearch",JSON.stringify(data))
              localStorage.setItem("lastCustomerSearch",JSON.stringify(filterData.subscriberid))
            }
            if (newurl == '/lco/v1/plan.php') {
              let setPlan = {}
              setPlan[queryStr] = data
              planListingData.push (setPlan)
            }
            resolve(data) 
          }).catch((error) => {
            reject(error);
          });
        });
    },
    getChannelList: (context, filterData) => {
      console.log("got response in report module",filterData)
    return new Promise( (resolve, reject) => {
      let data = {}
      data.plancode = filterData;
      let queryStr = ''
      queryStr = makeQueryStringDync(data)
           
      fetch(context.getters.baseUrl + '/lco/v1/plan/channel' + queryStr, {
        method: 'GET'
        })
        .then(errorServeiceHandler)
        .then((response) => {
            return response.json()
          }).then((data) => {
              resolve(data)
          }).catch((error) => {
            reject(error);
          });
        });
    },
    getMonsoonPack: (context, queryStr) => {
      queryStr = makeQueryStringDync(queryStr)
      return new Promise((resolve, reject) => {
          fetch(context.getters.baseUrl + '/lco/v1/plan/imclschemes' + queryStr, {
            method: 'GET'
          })
              .then(errorServeiceHandler)
              .then((response) => {
                  return response.json()
              }).then((data) => {
                  resolve(data)
              }).catch((error) => {
                  reject(error)
              });
      });
    },
    sendOTPToUser: (context, payload) => {
      let data = makeQueryFormDataDyn(payload)
      return new Promise((resolve, reject) => {
          fetch(context.getters.baseUrl + '/lco/v1/customer/otp', {
            method: 'POST',
            body: data
          })
              .then(errorServeiceHandler)
              .then((response) => {
                  return response.json()
              }).then((data) => {
                  resolve(data)
              }).catch((error) => {
                  reject(error)
              });
      });
    },
    verifyUserOTP: (context, queryStr) => {
      return new Promise((resolve, reject) => {
         queryStr = makeQueryStringDync(queryStr);
         fetch(context.getters.baseUrl + '/lco/v1/customer/otp/verify' + queryStr, {
          method: 'GET'
         })
         .then(errorServeiceHandler)
         .then((response) => {
            return response.json()    
         }).then((data) => {
              resolve(data)
          }).catch((error) => {
              reject(error)
          });
      });
    },
    downloadMasterPlanList: (context,filterData) => {
      return new Promise((resolve, reject) => {
        let queryStr = ''
        queryStr = makeQueryStringDync(filterData)
          fetch(context.getters.baseUrl + '/lco/v1/plan' + queryStr, {
              method: 'GET'
          })
              .then(errorServeiceHandler)
              .then((response) => {
                  return response.json()
              }).then((data) => {
                  resolve(data)
              }).catch((error) => {
                  if (context.getters.getMode == "development") {
                    resolve([{"planid":"OJt8QA3D","planname":"FILAMCHI","plantype":"CHANNEL","plancode":"ALA0700PP","servicecode":"[\"ALA0700CS\"]","packagecode":"","description":"FILAMCHI","lcoprice":"0.09","mrptariff":"0.09","tariffperiod":"1","currency":"INR","region":"MUM","lcoregion":"MUM","status":"ACTIVE","planmode":"RENEWABLE","tariffperiodtype":"M","effectivedate":null,"newlcoprice":null,"newmrptariff":null,"ncfprice":"0.00","discountedlcoprice":null,"renewperiod":"12","hardwaretype":"ALL","plancategory":"NORMAL","numchannels":"239"},{"planid":"Gd0hcCu5","planname":"HD EUROSPORT","plantype":"CHANNEL","plancode":"ALA0696PP","servicecode":"[\"ALA0696CS\"]","packagecode":"","description":"HD EUROSPORT","lcoprice":"5.40","mrptariff":"6.00","tariffperiod":"1","currency":"INR","region":"MUM","lcoregion":"MUM","status":"ACTIVE","planmode":"RENEWABLE","tariffperiodtype":"M","effectivedate":null,"newlcoprice":null,"newmrptariff":null,"ncfprice":"0.00","discountedlcoprice":null,"renewperiod":"12","hardwaretype":"ALL","plancategory":"NORMAL","numchannels":"1","url":"https:\/\/s3.ap-south-1.amazonaws.com\/com.kyc.dpcollection.incablenet.mum\/images\/oohq7FSV.png"},{"planid":"7ZluYF9R","planname":"OTT PLAN","plantype":"CHANNEL","plancode":"OTTPLAN","servicecode":"[\"OTTSERVICE\"]","packagecode":"","description":"OTT PLAN","lcoprice":"1800.00","mrptariff":"1800.00","tariffperiod":"6","currency":"INR","region":"MUM","lcoregion":"MUM","status":"ACTIVE","planmode":"RENEWABLE","tariffperiodtype":"M","effectivedate":null,"newlcoprice":null,"newmrptariff":null,"ncfprice":"0.00","discountedlcoprice":null,"renewperiod":"12","hardwaretype":"ALL","plancategory":"NORMAL","numchannels":"0"},{"planid":"MihDE2e5","planname":"OTT PLAN","plantype":"CHANNEL","plancode":"OTTPLAN","servicecode":"[\"OTTSERVICE\"]","packagecode":"","description":"OTT PLAN","lcoprice":"3600.00","mrptariff":"3600.00","tariffperiod":"12","currency":"INR","region":"MUM","lcoregion":"MUM","status":"ACTIVE","planmode":"RENEWABLE","tariffperiodtype":"M","effectivedate":null,"newlcoprice":null,"newmrptariff":null,"ncfprice":"0.00","discountedlcoprice":null,"renewperiod":"12","hardwaretype":"ALL","plancategory":"NORMAL","numchannels":"0"},{"planid":"XX4u9SfH","planname":"OTT PLAN","plantype":"CHANNEL","plancode":"OTTPLAN","servicecode":"[\"OTTSERVICE\"]","packagecode":"","description":"OTT PLAN","lcoprice":"300.00","mrptariff":"300.00","tariffperiod":"30","currency":"INR","region":"MUM","lcoregion":"MUM","status":"ACTIVE","planmode":"RENEWABLE","tariffperiodtype":"D","effectivedate":null,"newlcoprice":null,"newmrptariff":null,"ncfprice":"0.00","discountedlcoprice":null,"renewperiod":"12","hardwaretype":"ALL","plancategory":"NORMAL","numchannels":"0"},{"planid":"VvfdRUMU","planname":"OTT PLAN","plantype":"CHANNEL","plancode":"OTTPLAN","servicecode":"[\"OTTSERVICE\"]","packagecode":"","description":"OTT PLAN","lcoprice":"1800.00","mrptariff":"1800.00","tariffperiod":"90","currency":"INR","region":"MUM","lcoregion":"MUM","status":"ACTIVE","planmode":"RENEWABLE","tariffperiodtype":"D","effectivedate":null,"newlcoprice":null,"newmrptariff":null,"ncfprice":"0.00","discountedlcoprice":null,"renewperiod":"12","hardwaretype":"ALL","plancategory":"NORMAL","numchannels":"0"},{"planid":"8El13Vr6","planname":"OTTPREPAID","plantype":"CHANNEL","plancode":"OTTPREPAID","servicecode":"[\"OTTSERVICE\"]","packagecode":"","description":"OTTPREPAID","lcoprice":"1800.00","mrptariff":"1800.00","tariffperiod":"6","currency":"INR","region":"MUM","lcoregion":"MUM","status":"ACTIVE","planmode":"RENEWABLE","tariffperiodtype":"M","effectivedate":null,"newlcoprice":null,"newmrptariff":null,"ncfprice":"0.00","discountedlcoprice":null,"renewperiod":"12","hardwaretype":"ALL","plancategory":"NORMAL","numchannels":"0"},{"planid":"6gBtxEEm","planname":"OTTPREPAID","plantype":"CHANNEL","plancode":"OTTPREPAID","servicecode":"[\"OTTSERVICE\"]","packagecode":"","description":"OTTPREPAID","lcoprice":"3600.00","mrptariff":"3600.00","tariffperiod":"12","currency":"INR","region":"MUM","lcoregion":"MUM","status":"ACTIVE","planmode":"RENEWABLE","tariffperiodtype":"M","effectivedate":null,"newlcoprice":null,"newmrptariff":null,"ncfprice":"0.00","discountedlcoprice":null,"renewperiod":"12","hardwaretype":"ALL","plancategory":"NORMAL","numchannels":"0"},{"planid":"oQ3Cebh2","planname":"OTTPREPAID","plantype":"CHANNEL","plancode":"OTTPREPAID","servicecode":"[\"OTTSERVICE\"]","packagecode":"","description":"OTTPREPAID","lcoprice":"300.00","mrptariff":"300.00","tariffperiod":"30","currency":"INR","region":"MUM","lcoregion":"MUM","status":"ACTIVE","planmode":"RENEWABLE","tariffperiodtype":"D","effectivedate":null,"newlcoprice":null,"newmrptariff":null,"ncfprice":"0.00","discountedlcoprice":null,"renewperiod":"12","hardwaretype":"ALL","plancategory":"NORMAL","numchannels":"0"},{"planid":"F9SjXTCi","planname":"OTTPREPAID","plantype":"CHANNEL","plancode":"OTTPREPAID","servicecode":"[\"OTTSERVICE\"]","packagecode":"","description":"OTTPREPAID","lcoprice":"1800.00","mrptariff":"1800.00","tariffperiod":"90","currency":"INR","region":"MUM","lcoregion":"MUM","status":"ACTIVE","planmode":"RENEWABLE","tariffperiodtype":"D","effectivedate":null,"newlcoprice":null,"newmrptariff":null,"ncfprice":"0.00","discountedlcoprice":null,"renewperiod":"12","hardwaretype":"ALL","plancategory":"NORMAL","numchannels":"0"}])
                  } else {
                  reject(error)
                  }
              });
      });
    },
    getDiscontinuedPacksDetails: (context,filterData) => {
      return new Promise((resolve, reject) => {
        let queryStr = ''
        queryStr = makeQueryStringDync(filterData)
          fetch(context.getters.baseUrl + '/lco/v1/plan/discontinued'  + queryStr, {
            method: 'GET'
          })
          .then(errorServeiceHandler)
          .then((response) => {
            return response.json()
          }).then((data) => {
            resolve(data)
          }).catch((error) => {
            if (context.getters.getMode == "development") {
              resolve([{"plancode":"ALA0001PP","expiry":"2022-06-06 00:00:00","planname":"FOUNDATION + BANGLA POWER INDIA PACK","plancategory":"NCF","plantype":"PACKAGE","numchannels":"1","channellist":true,"recommended_plancode":"[\"ALA0002PP\",\"ALA0003PP\"]","planname":"ENGLISH PREMIUM","plantype":"PACKAGE","plancategory":"NORMAL","numchannels":"84"},{"plancode":"INB0015PP","expiry":"2022-05-30 00:00:00","recommended_plancode":"[\"ALA0002PP\",\"ALA0003PP\"]","planname":"BENGALI PREMIUM","plantype":"PACKAGE","plancategory":"NORMAL","numchannels":"72"},{"plancode":"ALA0002PP","expiry":"2022-05-05 00:00:00","recommended_plancode":"[\"ALA0002PP\",\"ALA0003PP\"]","planname":"&PICTURES","plantype":"CHANNEL","plancategory":"NCF","numchannels":"1"},{"plancode":"BQ00060PP","expiry":"2022-05-05 00:00:00","recommended_plancode":"[\"ALA0002PP\",\"ALA0003PP\"]","planname":"DISNEY KIDS PACK","plantype":"PACKAGE","plancategory":"NCF","numchannels":"4"},{"plancode":"BQ00082PP","expiry":"2022-05-05 00:00:00","recommended_plancode":"[\"ALA0002PP\",\"ALA0003PP\"]","planname":"ZEE FAMILY PACK ALL SOUTH SD","plantype":"PACKAGE","plancategory":"NCF","numchannels":"19"},{"plancode":"BQ00087PP","expiry":"2022-05-05 00:00:00","recommended_plancode":"[\"ALA0002PP\",\"ALA0003PP\"]","planname":"COLORS WALA HINDI VALUE PLUS","plantype":"PACKAGE","plancategory":"NCF","numchannels":"22"},{"plancode":"BQ00094PP","expiry":"2022-05-05 00:00:00","recommended_plancode":"[\"ALA0002PP\",\"ALA0003PP\"]","planname":"COLORS WALA GUJARAT BUDGET PLUS","plantype":"PACKAGE","plancategory":"NCF","numchannels":"17"},{"plancode":"BQ00341PP","expiry":"2022-05-05 00:00:00","recommended_plancode":"[\"ALA0002PP\",\"ALA0003PP\"]","planname":"STAR VALUE PACK TAMIL-TELUGU","plantype":"PACKAGE","plancategory":"NCF","numchannels":"12"},{"plancode":"INB0028PP","expiry":"2022-05-05 00:00:00","recommended_plancode":"[\"ALA0002PP\",\"ALA0003PP\"]","planname":"ENGLISH STARTER","plantype":"PACKAGE","plancategory":"NORMAL","numchannels":"45"},{"plancode":"INB0033PP","expiry":"2022-05-05 00:00:00","recommended_plancode":"[\"ALA0002PP\",\"ALA0003PP\"]"},{"plancode":"ALA0001PP","expiry":"2022-05-10 00:00:00","planname":"Z NEWS","plancategory":"NCF","plantype":"PACKAGE","numchannels":"1","channellist":true,"recommended_plancode":['1','2']},{"plancode":"ALA0001PP","expiry":"2022-05-05 00:00:00","planname":"Z NEWS","plancategory":"NCF","plantype":"PACKAGE","numchannels":"1","channellist":true},{"plancode":"ALA0001PP","expiry":"2022-05-05 00:00:00","planname":"Z NEWS","plancategory":"NCF","plantype":"PACKAGE","numchannels":"1","channellist":true},{"plancode":"ALA0001PP","expiry":"2022-05-05 00:00:00","planname":"Z NEWS","plancategory":"NCF","plantype":"PACKAGE","numchannels":"1","channellist":true},{"plancode":"ALA0001PP","expiry":"2022-05-05 00:00:00","planname":"Z NEWS","plancategory":"NCF","plantype":"PACKAGE","numchannels":"1","channellist":true},{"plancode":"ALA0001PP","expiry":"2022-05-05 00:00:00","planname":"Z NEWS","plancategory":"NCF","plantype":"PACKAGE","numchannels":"1","channellist":true},{"plancode":"ALA0001PP","expiry":"2022-05-05 00:00:00","planname":"Z NEWS","plancategory":"NCF","plantype":"PACKAGE","numchannels":"1","channellist":true},{"plancode":"ALA0001PP","expiry":"2022-05-05 00:00:00","planname":"Z NEWS","plancategory":"NCF","plantype":"PACKAGE","numchannels":"1","channellist":true},{"plancode":"ALA0001PP","expiry":"2022-05-05 00:00:00","planname":"Z NEWS","plancategory":"NCF","plantype":"PACKAGE","numchannels":"1","channellist":true},{"plancode":"ALA0001PP","expiry":"2022-05-05 00:00:00","planname":"Z NEWS","plancategory":"NCF","plantype":"PACKAGE","numchannels":"1","channellist":true},{"plancode":"ALA0001PP","expiry":"2022-05-05 00:00:00","planname":"Z NEWS","plancategory":"NCF","plantype":"PACKAGE","numchannels":"1","channellist":true}])
              return
            } 
            reject(error)
          });
      });
    },
    getRecommendedPlanList: (context,filterData) => {
      return new Promise((resolve, reject) => {
        let queryStr = ''
        queryStr = makeQueryStringDync(filterData)
          fetch(context.getters.baseUrl + '/lco/v1/plan/discontinued' + queryStr, {
            method: 'GET'
          })
          .then(errorServeiceHandler)
          .then((response) => {
            return response.json()
          }).then((data) => {
            resolve(data)
          }).catch((error) => {
            if (context.getters.getMode == "development") {
              resolve([{"planname":"COLORS WALA GUJARAT FAMILY","plancode":"BQ00096PP","lcoprice":"27.00","ncfprice":"0.00","plantype":"PACKAGE","plancategory":"NCF","numchannels":"29"},{"planname":"COLORS WALA KERALA BUDGET PLUS","plancode":"BQ00090PP","lcoprice":"7.20","ncfprice":"0.00","plantype":"PACKAGE","plancategory":"NCF","numchannels":"12"},{"planname":"MAVIS SATCOM BOUQUET 1","plancode":"BQ00147PP","lcoprice":"5.40","ncfprice":"0.00","plantype":"PACKAGE","plancategory":"NCF","numchannels":"4"},{"planname":"NDTV ULTRA","plancode":"BQ00148PP","lcoprice":"3.15","ncfprice":"0.00","plantype":"PACKAGE","plancategory":"NCF","numchannels":"4"},{"planname":"OTT PLAN","plancode":"OTT00001PP","lcoprice":"300.00","ncfprice":"0.00","plantype":"CHANNEL","plancategory":"NORMAL","numchannels":"5"}])
              return
            } 
            reject(error)
          });
      });
    },
};

export default {
    state, getters, mutations, actions
};



// WEBPACK FOOTER //
// ./src/store/modules/productModule/addpacksModule.js